
import { Component, Prop, Vue } from "vue-property-decorator";
import NotificationBell from "@/components/V2/Notifications/NotificationBell.vue";
import AppUser from "@/components/V2/AppUser/AppUser.vue";

@Component({
  components: {
    AppUser,
    NotificationBell,
  },
})
export default class AppProfile extends Vue {
  @Prop({ type: String, default: null }) readonly image: string;
  @Prop({ type: String, default: null }) readonly name: string;
}
